import React, { useEffect, useState } from 'react';

import { Search as SearchIcon } from 'react-feather';

import {
  Box,
  Card,
  CardContent,
  InputAdornment,
  SvgIcon,
  TextField,
  MenuItem,
  Select as Select1,
  Button,
} from '@material-ui/core';

import Select from 'react-select';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  DatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';

import moment from 'moment';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CustomerAction } from 'src/actions/customer.action';
import { AccountAction } from 'src/actions/account.acction';
import { saveAs } from 'file-saver';
import { AppAction } from 'src/actions/app.action';
import * as XLSX from 'xlsx';

const CustomerCareHistoryListToolbar = (props) => {
  const dispatch = useDispatch();
  const { filter } = useSelector(state => state.customer)
  const { items, total } = useSelector(state => state.account)
  const { info, permissions, role } = useSelector(state => state.profile)
  const [values, setValues] = useState({
    username: "",
    phone: "",
    status: "",
    startDate: dayjs(filter.startDate, moment(new Date()).format('DD/MM/YYYY')),
    endDate: dayjs(filter.endDate, moment(new Date()).format('DD/MM/YYYY')),
    startDateHen: '',
    endDateHen: '',
  });

  const handleStartDateChange = (date) => {
    setValues({
      ...values,
      startDate: date,
      endDate: values.endDate == '' ? date : values.endDate,
      startDateHen: '',
      endDateHen: '',
    });
  };

  const handleEndDateChange = (date) => {
    setValues({
      ...values,
      startDate: values.startDate == '' ? date : values.startDate,
      endDate: date,
      startDateHen: '',
      endDateHen: '',
    });
  };

  const handleStartDateHenChange = (date) => {
    setValues({
      ...values,
      startDateHen: date,
      endDateHen: values.endDateHen == '' ? date : values.endDateHen,
      startDate: '',
      endDate: '',
    });
  };

  const handleEndDateHenChange = (date) => {
    setValues({
      ...values,
      startDateHen: values.startDateHen == '' ? date : values.startDateHen,
      endDateHen: date,
      startDate: '',
      endDate: '',
    });
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleUsernameChange1 = (name, newValue) => {
    setValues({
      ...values,
      [name]: newValue
    });
  };

  useEffect(() => {
    const today = new Date();

    const payload = {
      page: 0,
      limit: DEFAULT_ROW_PER_PAGE,
      username: "",
      phone: "",
      status: "",
      startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)).format("DD/MM/YYYY"),
      endDate: dayjs(today).format("DD/MM/YYYY"),
      startDateHen: '',
      endDateHen: '',
    };
    dispatch(CustomerAction.updateFilter(payload));
    dispatch(AccountAction.listNoLimit());
  }, []);

  const onLookup = () => {
    const payload = {
      page: 'no_update',
      limit: 'no_update',
      username: values.username,
      phone: values.phone,
      status: values.status,
      startDate: values.startDate != '' ? values.startDate.format("DD/MM/YYYY") : '',
      endDate: values.endDate != '' ? values.endDate.format("DD/MM/YYYY") : '',
      startDateHen: values.startDateHen != '' ? values.startDateHen.format("DD/MM/YYYY") : '',
      endDateHen: values.endDateHen != '' ? values.endDateHen.format("DD/MM/YYYY") : '',
    };
    dispatch(CustomerAction.updateFilter(payload));
    dispatch(CustomerAction.history())
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onLookup();
    }
  };

  const xuatFile = async () => {
    if (role.priority == 5) return;
    dispatch(AppAction.appLoading(true))
    try {
      const payload = {
        getAll: true,
        username: values.username,
        phone: values.phone,
        status: values.status,
        startDate: values.startDate.format("DD/MM/YYYY"),
        endDate: values.endDate.format("DD/MM/YYYY"),
      };
      dispatch(CustomerAction.updateFilter(payload));
      const response = await dispatch(CustomerAction.history());
      console.log(response)

      const data = [
        [
          '#', 
          'Username nhân viên', 
          'Tên nhân viên', 
          'Số điện thoại', 
          'Gói cước', 
          'Kết quả', 
          'Thời gian hẹn lại (nếu có)',
          'Lý do',
          'Thời điểm chăm sóc',
        ],
      ];

      if (typeof response !== 'undefined' && response != null && typeof response.data !== 'undefined' && response.data && typeof response.data.values !== 'undefined' && response.data.values && response.data.values.length > 0) {
        var count = 1;
        response.data.values.forEach((element) => {
          let status = "";

          if (element.status == "APPROVED") status = "Đồng ý";
          else if (element.status == "REJECTED") status = "Không đồng ý";
          else if (element.status == "APPOINTMENT") status = "Hẹn lại";
          else if (element.status == "KBM") status = "Không bắt máy";
          else if (element.status == "KLLĐ") status = "Không liên lạc được";
          else if (element.status == "KEEP") status = "Dùng lại gói cũ";
          else if (element.status == "RE-REGISTER") status = "Đã đăng ký lại";

          data.push([
            count,
            element.username,
            element.fullname,
            role.priority < 3 ? element.phone.slice(-9) : ('****' + element.phone.slice(-5)),
            element.package,
            status,
            element.appointment_at ? moment(element.appointment_at).format('DD-MM-YYYY HH:mm:ss') : '',
            element.note ? element.note : '',
            moment(element.created_at).format('DD-MM-YYYY HH:mm:ss'),
          ])
          count++;
        })

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'NHAT-KY-CSKH.xlsx');
      }

      dispatch(AppAction.appLoading(false))
    } catch (error) {
      if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
    }
  }

  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card className="filter_card" style={{overflow: 'visible'}}>
          <CardContent>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ 
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
                <div style={{ width: '250px', zIndex: '10' }} className="full-width-select">
                  <Select
                    classNamePrefix="nt-select"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({
                        ...base,
                        zIndex: 999999,
                      }),
                      control: (provided) => ({
                        ...provided,
                        height: 56,
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      }),
                      option: (provided) => ({
                        ...provided,
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      }),
                    }}
                    options={items}
                    getOptionLabel={(item) => `${item.role.priority == 4 ? '--' : (item.role.priority == 5 ? '----' : '')} ${item.username} - ${item.fullname}`}
                    placeholder={values.username || "Chọn nhân viên..."}
                    components={{
                      DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                      IndicatorSeparator: null,
                    }}
                    value={values.username || null}
                    onChange={(newValue) => handleUsernameChange1('username', newValue.username)}
                    isSearchable
                  />
                </div>
                <DatePicker
                  label="Thời gian chăm sóc bắt đầu"
                  style={{ width: '100%', marginRight: 24 }}
                  format='DD/MM/YYYY'
                  value={values.startDate}
                  onChange={(newValue) => handleStartDateChange(newValue)}
                  />
                <DatePicker
                  label="Thời gian chăm sóc kết thúc"
                  style={{ width: '100%', marginLeft: 24 }}
                  value={values.endDate}
                  format='DD/MM/YYYY'
                  onChange={(newValue) => handleEndDateChange(newValue)}
                />
                <DatePicker
                  label="Thời gian hẹn bắt đầu"
                  style={{ width: '100%', marginRight: 24 }}
                  format='DD/MM/YYYY'
                  value={values.startDateHen}
                  onChange={(newValue) => handleStartDateHenChange(newValue)}
                  />
                <DatePicker
                  label="Thời gian hẹn kết thúc"
                  style={{ width: '100%', marginLeft: 24 }}
                  value={values.endDateHen}
                  format='DD/MM/YYYY'
                  onChange={(newValue) => handleEndDateHenChange(newValue)}
                />
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SvgIcon
                          fontSize="small"
                          color="action"
                          >
                          <SearchIcon />
                        </SvgIcon>
                      </InputAdornment>
                    )
                  }}
                  name="phone"
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  value={values.phone}
                  placeholder="Tìm SĐT"
                  variant="outlined"
                />
                <Select1
                  style={{ height: 56, width: "200px", marginLeft: 0 }}
                  name="status"
                  value={values.status || -99}
                  onChange={(newValue) => handleChange(newValue)}
                  variant="outlined"
                  startAdornment={(
                    <InputAdornment position="start">
                      <SvgIcon fontSize="small" color="action">
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  )}
                >
                  <MenuItem value="-99">Kết quả...</MenuItem>
                  <MenuItem value="APPROVED">Đồng ý</MenuItem>
                  <MenuItem value="REJECTED">Không đồng ý</MenuItem>
                  <MenuItem value="APPOINTMENT">Hẹn lại</MenuItem>
                  <MenuItem value="KBM">Không bắt máy</MenuItem>
                  <MenuItem value="KLLĐ">Không liên lạc được</MenuItem>
                  <MenuItem value="KEEP">Dùng lại gói cũ</MenuItem>
                  <MenuItem value="RE-REGISTER">Đã đăng ký lại</MenuItem>
                </Select1>
                {role.priority != 5 && <Button
                  color="primary"
                  variant="contained"
                  onClick={xuatFile}
                  style={{ height: 56, marginTop: 0, width: "150px", marginLeft: 0 }}
                >
                  Xuất file
                </Button>}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={onLookup}
                  style={{ height: 56, marginTop: 0, width: 200, marginLeft: 24 }}
                  >
                  Tra cứu
                </Button>
              </Box>
            </LocalizationProvider>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
};

export default CustomerCareHistoryListToolbar;
